import React from "react";
import {
  Slider,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import {
  Pause,
  PlayArrow,
  VolumeUp,
  VolumeOff,
} from "@mui/icons-material";
import { styled } from "@mui/system";
import "./Control.css";

const VolumeSlider = styled(Slider)({
  width: "100px",
  color: "#9556CC",
});

const Control = ({
  onPlayPause,
  playing,
  onRewind,
  onForward,
  played,
  onSeek,
  onSeekMouseUp,
  onVolumeChangeHandler,
  onVolumeSeekUp,
  volume,
  mute,
  onMute,
  duration,
  currentTime,
  onMouseSeekDown,
  controlRef,
}) => {
  return (
    <div className="control_Container" ref={controlRef}>
      <div className="bottom__container">
        <Box className="control__box">
          <Box className="inner__controls" display="flex" alignItems="center">
            <IconButton onClick={onPlayPause}>
              {playing ? (
                <Pause fontSize="medium" sx={{ color: "#fff" }} />
              ) : (
                <PlayArrow fontSize="medium" sx={{ color: "#fff" }} />
              )}
            </IconButton>

            <IconButton onClick={onMute}>
              {mute ? (
                <VolumeOff fontSize="medium" sx={{ color: "#fff" }} />
              ) : (
                <VolumeUp fontSize="medium" sx={{ color: "#fff" }} />
              )}
            </IconButton>

            <VolumeSlider
              onChange={onVolumeChangeHandler}
              value={volume * 100}
              onChangeCommitted={onVolumeSeekUp}
            />

            <Typography variant="body2" color="white" ml={4}>
              {currentTime} : {duration}
            </Typography>
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default Control;
